// create a array of object and export it --------------------------
let CardInfo = [
    {
        outerimg:"  https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXLkVzlMFA1VpJ9DrOAF7XZg18QDoSK9xKxg&usqp=CAU",
        innerimg:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5l0vOTF9988Oany6jFXWp7mbQ42jsMMp-PPusPxEbdYXIzB2fIJMqyg4GFOKlNIKRNQo&usqp=CAU ",
        hname:"How to Use The Brain",
        description:"Psychology, Motivation, Self-help, Thinking, & Learning (Science & Experiences)",
    },
    {
        outerimg:"https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Money_Cash.jpg/1280px-Money_Cash.jpg   ",
        innerimg:" https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTot8fbfc3HMtuc98HLgad8x63ROhnrUS0faF8jx0WYXB81aeLC_HE-GXPJfMrOn19Ew-0&usqp=CAU ",
        hname:" Earn Money Online",
        description:" earn money while you sleep",
    },
    {
        outerimg:"  https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAA3KAevmThE7MeG8l6SQVhwSqi859F0tynw&usqp=CAU",
        innerimg:" https://www.howtogeek.com/wp-content/uploads/2022/12/ChatGPT.jpg?height=200p&trim=2,2,2,2&crop=16:9 ",
        hname:"ChatGPT Community ",
        description:" The space is focused on discussing & sharing knowledge about ChatGPT OpenAI.",
    }
    , {
        outerimg:" https://imageio.forbes.com/specials-images/imageserve/5eff8d9c9756420007f6f97b/Businesswoman-speaking-with-co-worker-in-open-office/960x0.jpg?format=jpg&width=960  ",
        innerimg:"https://zoets.b-cdn.net/wp-content/uploads/2017/04/Advanced-Communication-Skills-Training-Course.jpg ",
        hname:" Communication Skills",
        description:"Share your experiences to deal with people. Collab - agarwalsneha701@gmail.com ",
    }
    , {
        outerimg:"https://www.trendingnews.news/wp-content/uploads/2019/05/Self-Improvement.jpg  ",
        innerimg:" https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR5Q_JQPw9ZQLSMsUCDWsw_3gr8wEHsYcPHGw&usqp=CAU",
        hname:" Self Improvement & Habits",
        description:"Learn self improvement , Habits buildings to enhance your life ",
    }
    , {
        outerimg:" https://miro.medium.com/max/800/1*laaWLt7tYUazBOhuZahyUA.jpeg  ",
        innerimg:"https://pbs.twimg.com/profile_images/991517440352845824/59tI5gin_400x400.jpg  ",
        hname:"Programmer's World ",
        description:" You still a programmer? You still write code? This space is for you.",
    }
    , {
        outerimg:" https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTHZb2-Bu8HHbF72KympPwk8Wi3qs0pOyUxnA&usqp=CAU  ",
        innerimg:" https://blog.zolostays.com/wp-content/uploads/2022/04/1BCBF012-0E3E-4597-941E-77A1DE881CFC.png ",
        hname:" IT Companies & Employees",
        description:" Maximize your IT career potential",
    },
    {
        outerimg:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_YYUSBXizkTc0S-Sqib4suQhhf93BJYlcKw&usqp=CAU  ",
        innerimg:" https://www.omxtechnologies.com/wp-content/uploads/2022/06/SEO-INOVATION-WEBSITE-WPML-2020-1.jpg ",
        hname:"SEO",
        description:"All about Search engine optimisation.",
    },


];

export {CardInfo};